var map = {
	"./brands-collections-results.de-CH.json": 1236,
	"./brands-collections-results.de-DE.json": 1237,
	"./brands-collections-results.en-CA.json": 1238,
	"./brands-collections-results.en-GB.json": 1239,
	"./brands-collections-results.en-IN.json": 1240,
	"./brands-collections-results.en-ME.json": 1241,
	"./brands-collections-results.en-US.json": 1242,
	"./brands-collections-results.es-EM.json": 1243,
	"./brands-collections-results.es-ES.json": 1244,
	"./brands-collections-results.fr-BE.json": 1245,
	"./brands-collections-results.fr-CA.json": 1246,
	"./brands-collections-results.fr-CH.json": 1247,
	"./brands-collections-results.nl-BE.json": 1248,
	"./brands-collections-results.nl-NL.json": 1249,
	"./brands-collections-results.pl-PL.json": 1250,
	"./brands-collections-results.pt-BR.json": 1251
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1235;